import { Outlet } from "react-router-dom";
import MainNav from "components/Navigation/MainNav";
import Footer from "components/Footer";

const Default = () => {
  return (
    <>
      <MainNav />
      <div className="cc-container-m">
        <Outlet />
      </div>
      <Footer/>
    </>
  );
};

export default Default;
